
import { useEffect } from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { AddButton, CancelButton, DeleteButton, SaveButton } from '../../../../global/Button';
import AddAccessToGroupModal from './AddAccessToGroupModal';
import { AppModalAlert, useModalState } from '../../../../global/Modal';
import { IPermission } from '../../../../../compiler/global.interface';
import { FieldValues, useFieldArray, useForm, UseFormReturn, useWatch } from 'react-hook-form';
import ActionBar from '../../../../global/Widget/ActionBar';
import { useEditUserGroupByUUID } from '../../../../../hook/query/userCRUD';
import { useSnackbar } from 'notistack';
import { EHelperText } from '../../../../../utilitie/validation';
import { useSettingAccessUserPageContextContext } from '../../../../../pages/Setting/Access/User';
import { filter } from 'lodash';
export interface IUserMemberManageProps {
    useGroupForm: UseFormReturn<any, object>
}

export interface IUserMemberManageFormValues {
    id: number | null,
    group_master: {
        id: number | null,
        name: string | null
    }
}

export interface IMemberGroupFieldValue {
    id: any,
    name: string,
    option: string,
    group_master_uuid: string,
    value: string,
    is_remove: number,
}

export const DUserMemberManageFormValues = {
    id: null,
    group_master: {
        id: null,
        name: ""
    }
}

export interface IPermissionData extends IPermission {
    id: any, is_remove: number, group_master: { name: string }
}

export default function UserMemberManage({ useGroupForm, ...other }: IUserMemberManageProps) {
    const { uuid, defaultValues } = useSettingAccessUserPageContextContext()

    const { enqueueSnackbar } = useSnackbar()

    const [modalState, setModalState, toggleModalState] = useModalState()

    const { mutateAsync: editUserGroupByUUID, isLoading: editUserGroupByUUIDLoading } = useEditUserGroupByUUID(uuid)

    const { control, reset, setValue, handleSubmit, getValues, formState: { isValid } } = useGroupForm

    const groupField = useFieldArray({ control, name: 'group' })

    const currentGroup = useWatch({ control, name: 'group' }) as unknown as IPermissionData[]

    const handleAddGroupConfirm = (e, values) => {
        // console.log(values,'@@values')
        setValue('group', values)
        toggleModalState(false, '')
    }

    const handleDelete = (index) => {
        // setValue(`group[${index}].is_remove` as unknown as 'group', 1 as any)
        groupField.remove(index)
    }

    const handleCancel = () => {
        reset(defaultValues.useGroupForm)
    }

    const _handleSubmit = async (values: FieldValues) => {
        let checkRemove = defaultValues.useGroupForm.group?.map(group => ({
            ...group,
            is_remove: values.group.find(_group => _group.group_master_uuid === group.group_master_uuid) ? 0 : 1
        }))

        let payload = [...checkRemove, ...values.group.map(group => ({ ...group, is_remove: 0 }))].filter((v, i, a) => a.findIndex(t => (t.group_master_uuid === v.group_master_uuid)) === i) as IMemberGroupFieldValue[]

        await editUserGroupByUUID(payload).then(() => {
            enqueueSnackbar(EHelperText.UPDATED_SUCCESS, { variant: 'success' })
        }).catch((error) => {
            enqueueSnackbar(EHelperText.AN_ERROR_OCCURRED, { variant: 'error' })
        })
    }

    const isReadyToAction = !editUserGroupByUUIDLoading && isValid && currentGroup?.length > 0

    return (
        <>
            {
                modalState.open && <AddAccessToGroupModal currentGroup={currentGroup} title='เพิ่มกลุ่ม' open={true} onCancel={() => toggleModalState(false)} onClose={() => toggleModalState(false)} onConfirm={handleAddGroupConfirm} />
            }
            <AppModalAlert hideBackdrop title='เพิ่มกลุ่ม' open={!!modalState.status} status={modalState.status} onClose={() => toggleModalState(false)} />
            <Stack height={'100%'}>
                <AddButton onClick={() => toggleModalState(true)} fullWidth variant='contained' sx={{ borderRadius: 0, border: 0, ':hover': { border: 0 } }}>เพิ่มกลุ่มผู้ใช้งาน</AddButton>
                <Stack flex={1} overflow={'auto'}>
                    {groupField.fields?.filter((item: any) => item.is_remove === 0).map((group: any, index: number) => (
                        <Stack sx={{ bgcolor: index % 2 === 0 ? 'grey.100' : 'common.white' }} key={index} className='row' px={4} py={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                            <Box><Typography>{group.name}</Typography></Box>
                            <Box>
                                <DeleteButton onClick={() => handleDelete(index)} />
                            </Box>
                        </Stack>
                    ))}
                </Stack>
                <ActionBar>
                    <CancelButton disabled={!isReadyToAction} onClick={handleCancel}>ยกเลิก</CancelButton>
                    <SaveButton disabled={!isReadyToAction} onClick={handleSubmit(_handleSubmit, error => console.error(error))}>บันทึก</SaveButton>
                </ActionBar>
            </Stack>
        </>
    );
}
